import React, {useState, useEffect} from 'react';
import KickImage from 'Reuseables/KickImage';
import {Modal, Row, Col} from "reactstrap"
import ModalAddressBook from "./ModalAddressBookV2"

// Icon
import CloseIcon from '../../images/close-button-black.png';
import ArrowDown from "../../images/arrowsDown.png"
import ArrowNext from "../../images/arrowsNext.png"
import UploadIcon from "../../images/img-upload-icon.png"

import ExitIcon from "../../images/circle-close-button.png"

import { getHistoryShipping } from "../../actions/postalCodeAction"

import { putConcierge, getConcierge } from "../../actions/productAction"

import CloseButtonSuccessModal from "../../images/close-button-search.png"
import SuccessEnvelope from "../../images/success-concierge.png"
import ErrorEnvelope from "../../images/fail-concierge.png"

import { connect } from "react-redux"
import InputNumber from 'Reuseables/InputNumber/InputNumber';


function ModalEditConcierge({isOpen, toggle, title, item, countries, getHistoryShipping, provinces, cities, shippingHistory, putConcierge, getConcierge}) {
  const [selectedOption, setSelectedOption] = useState(item.phone_number.slice(0, 2))
  const [phone, setPhone] = useState(item.phone_number.slice(2, item.phone_number.length))
  const [file, setFile] = useState("")
  const [imageUrl, setImageUrl] = useState(item.concierge_images[0].URL)
  const [proceed, setProceed] = useState(false)
  const [selectedShipping, setSelectedShipping] = useState(item.shipping.alias)
  const [modalToggle, setModalToggle] = useState(false)
  const [error, setError] = useState("")
  const [shippingId, setShippingId] = useState(item.shipping_id)
  const [submitError, setSubmitError] = useState(false)
  const [canSubmit, setCanSubmit] = useState(false)
  const [submitSuccessfull, setSubmitSuccessful] = useState(false)
  const [selectedAddress, setSelectedAddress] = useState(0)

  useEffect(() => {
    if((selectedOption !== item.phone_number.slice(0, 2) || phone !== item.phone_number.slice(2, item.phone_number.length) || imageUrl !== item.concierge_images[0].URL || shippingId !== item.shipping_id ) && (imageUrl !== "" && phone.length > 5)){
      setCanSubmit(true)
    } else {
      setCanSubmit(false)
    }
  }, [selectedOption, phone, imageUrl, shippingId])

  useEffect(() => {
    if (item.shipping_id !== selectedAddress) {
      setSelectedAddress(item.shipping_id)
    }
  }, [selectedAddress])

  function updateConcierge(e){
    e.preventDefault()

    const payload = {
      phone_number: parseInt(selectedOption + phone),
      shipping_id: shippingId,
    }
    
    putConcierge(item.id, payload)
    .then(_ => getConcierge())
    .then(_ => submitOnToggle())
    .catch(e => null)
  }

  function optionSelect(e){
    setSelectedOption(e.target.value)
  }

  function shippingSelect(e){
    setSelectedShipping(e.target.value)
  }
  
  function showModal(){
    setModalToggle(!modalToggle)
  }

  function inputPhoneHandler(e){
    if(e.target.value > e.target.maxLength){
      e.target.value = e.target.value.slice(0, e.target.maxLength)
      setPhone(e.target.value)
    } else {
      setPhone(e.target.value)
    }
  }

  function phoneKeyPress(e) {
    let event = e || window.event;

    // Handle key only accept number
    let key = event.keyCode || event.which
    key = String.fromCharCode(key)

    const regex = /[0-9]|\./

    if(!regex.test(key)){
      event.returnValue = false
      if(event.preventDefault) event.preventDefault()
    }
  }

  function uploadImage(){
    document.getElementById("imageInput").click()
  }

  function handleImageInput(e) {
    e.preventDefault()

    let drive = new FileReader();
    let image = e.target.files[0]

    drive.onloadend = () => {
      setFile(image)
      setImageUrl(drive.result)
    }
    
    if (image && image.type.match('image.*')) {
      return drive.readAsDataURL(image);
    } else {
      return null
    }
  }

  function changeId(id){
    setShippingId(id)
    setSelectedAddress(id)
  }

  function showModal(){
    setModalToggle(!modalToggle)
  }

  function submitShipping(id){
    if(id){
      const temp = shippingHistory.filter(item => item.id === id)[0]
      setSelectedShipping(temp.alias)
      setShippingId(temp.id)
      setModalToggle(!modalToggle)
    } else {
      const temp = shippingHistory.filter(item => item.id === shippingId)[0]
      setSelectedShipping(temp.alias)
      setShippingId(temp.id)
      setModalToggle(!modalToggle)
      }
  }

  function handleClearImage(){
    setImageUrl("")
  }

  async function submitOnToggle(){
    await setSubmitSuccessful(!submitSuccessfull)

    if(submitSuccessfull){
      toggle()
    }
  }

  function submitErrorOnToggle(){
    setSubmitError(!submitError)
  }

  if(submitSuccessfull || submitError){
    return <Modal className={"modal-concierge-success-submit"} isOpen={submitSuccessfull ? submitSuccessfull : submitError} toggle={submitSuccessfull ? submitOnToggle : submitErrorOnToggle}>
      <div className="concierge-submit-modal">
      <KickImage onClick={submitSuccessfull ? submitOnToggle : submitErrorOnToggle} alt="Close modal" src={CloseButtonSuccessModal} className="close-button-success-modal" />
      <KickImage src={submitSuccessfull ? SuccessEnvelope : ErrorEnvelope} className="concierge-submit-envelope" alt="Successfully submit"/>
      {
        submitSuccessfull ? <div className="concierge-submit-text">
        <h4>Your request has been successfully updated!</h4>
      </div> : <div className="concierge-submit-text">
        <h4>There was an error submitting your request</h4>
      </div>
      }
      </div>
    </Modal>
  }
  else if(modalToggle){
    return <ModalAddressBook
    // titleModal="ADDRESS BOOK"
    isOpen={modalToggle}
    onToggle={showModal}
    dataAddress={shippingHistory}
    countries={countries}
    provinces={provinces}
    cities={cities}
    id={shippingId}
    changeId={changeId}
    submitShipping={submitShipping}
    getHistoryShipping={getHistoryShipping}
    isAddressButtonDisable={!(shippingHistory.length > 0) || shippingId === selectedAddress}
    // handleClickAddress={this._handleClearAddress}
    // selectedAddress={this._handleSelectedAddress}
  />    
  } else {
    return (
      <Modal className="modal-concierge-list" isOpen={isOpen} toggle={toggle}>
        <div className="concierge-list-container">
        <div className="concierge-list-header">
            <h4>{title}</h4>
            <KickImage onClick={() => toggle()} src={CloseIcon} alt="exit button"/>
          </div>
          <div style={{padding: "20px", overflowY: "scroll", height: "50vh", boxShadow: "none"}} className="concierge-right">
            <form>
              <h4 for="name">Name</h4>
              <input style={{backgroundColor: "#e4e4e4", cursor: "default", border: "solid 1px #a5a5a5", fontSize: "12px", color: "#6c6c6c"}} disabled={true} value={item.name} type="text" placeholder="Enter Your Name" />
              <h4>Phone Number</h4>
              <div>
                <select style={{background: `url(${ArrowDown})`, cursor: "pointer", fontSize: "12px"}} onChange={optionSelect} value={selectedOption}>
                  {
                    countries && countries.map(item => (
                      <option value={item.phone_code}>{`+${item.phone_code}`}</option>
                    ))
                  }
                </select>
                <InputNumber style={{fontSize: "12px"}} maxLength={16} onChange={inputPhoneHandler} value={phone} placeholder="Phone Number" />
              </div>
              <h4>Product Name</h4>
              <input style={{backgroundColor: "#e4e4e4", color: "#6c6c6c", cursor: "default", border: "solid 1px #a5a5a5", fontSize: "12px"}} disabled={true} value={item.product_name} type="text" placeholder="Enter Product Name" />
              <h4>Condition <span>(You can pick more than one)</span></h4>
              <div className="concierge-condition">
                <div style={{backgroundColor: "#e4e4e4", color: "#6c6c6c", cursor: "default", border: "solid 1px #a5a5a5", fontSize: "12px"}}>
                  Brand New
                </div>
                <div style={{backgroundColor: "#e4e4e4", color: "#6c6c6c", cursor: "default", border: "solid 1px #a5a5a5", fontSize: "12px"}}>
                  Used
                </div>
              </div>
              <h4>Shipping Address</h4>
              <div style={{background: `url(${ArrowNext})`, cursor: 'pointer', fontSize: "12px"}} className="concierge-shipping-address" onClick={() => showModal()}>
              {selectedShipping}
              </div>
              <h4>Upload Image</h4>
              {
                !imageUrl ? <div onClick={() => uploadImage()} className="upload-container">
                <div className="upload-content">
                  <input accept="image/*" onChange={handleImageInput} type="file" id="imageInput" style={{display: "none"}} />
                  <KickImage src={UploadIcon} alt="upload image here" />
                  <h6>Drag and drop your image here or <span>browse</span></h6>
                </div>
              </div> : <div className="image-container">
                <div style={{marginBottom: "0px"}} className="image-content">
                  <KickImage src={imageUrl} alt="upload image here" />
                </div>
              </div> 
              }
            </form>
          </div>
        </div>
          <div className="concierge-edit-submit">
            <input onClick={(e) => updateConcierge(e)} style={canSubmit ? {backgroundColor: "#242424", color: "#ffff", borderRadius: "5px", marginBottom: '15px'} : {color: "#a7a7a7", marginBottom: "15px"}} type="submit"/>
          </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  shippingHistory: state.dataPostalCode.shippingHistory.data,
  countries: state.dataPostalCode.countries.data,
  cities: state.dataPostalCode.cities.data,
  provinces: state.dataPostalCode.provinces.data,
  isLoggedIn: state.dataAuth.isLogged,
  conciergeData: state.dataProduct.concierge.data
})

const mapDispatchToProps = dispatch => ({
  getHistoryShipping: () => dispatch(getHistoryShipping()),
  putConcierge: (id, payload) => dispatch(putConcierge(id, payload)),
  getConcierge: () => dispatch(getConcierge())
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditConcierge);